import * as React from 'react'
import MenuItem from '@mui/material/MenuItem'
import { TextField, Typography } from '@mui/material'
import { InputProps } from '@/types/input.types'
import CustomView from './CustomView'
export default function FormSelectInput({
  id,
  name,
  value,
  label,
  options,
  onChange,
  withBorder = false,
  errorMessage,
  helperText,
  disabled
}: InputProps) {
  return (
    <CustomView>
      <TextField
        disabled={disabled}
        style={{
          width: '100%',
          background: 'white',
          maxHeight: '52px'
        }}
        className="px-2 my-2"
        variant="outlined"
        name={name}
        id={id}
        sx={{
          '.MuiInputBase-input': { fontSize: 16 },
          '.MuiInputLabel-outlined': { fontSize: 14 },
          '.MuiOutlinedInput-notchedOutline': { border: withBorder ? '' : 'unset', fontSize: 12 },
          '.MuiSelect-select': { minHeight: '1.1em !important', marginTop: '2px' }
        }}
        select
        label={label}
        value={value}
        onChange={onChange}
      >
        {options &&
          options.map((option, index) => (
            <MenuItem key={index} sx={{ fontSize: 16 }} value={option}>
              {option}
            </MenuItem>
          ))}
      </TextField>
      {errorMessage ? (
        <Typography fontSize="12px" color="red" mt="6px">
          {errorMessage}
        </Typography>
      ) : (
        <Typography fontSize="12px" color="#00000099" mt="3px" ml='14px'>
          {helperText}
        </Typography>
      )
      }
    </CustomView>
  )
}
